export const HASH_CODE_MAX = 2147483647;
export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;
